import { ProductActionType } from '../action-types/productTypes';
import { ProductActions } from '../actions/productTypes';

export interface ProductState {
  productPlan?: ProductPlan;
  productPlanLoaded: boolean;
  filteredProductPlan: ProductPlan;
  selectedProduct?: SinglePlan;
  precontractualInfo?: PrecontractualInfo;
  payPageHandles?: PayPageHandles;
  creditAccepted: boolean;
  paypalToken?: string;
  paypalNounce?: string;
  contract?: Contract;
  recordOfAdviceUrl?: string | null;
  preciItems: Array<{ urlType: string }>;
}

const initialState: ProductState = {
  productPlan: undefined,
  productPlanLoaded: false,
  filteredProductPlan: [],
  selectedProduct: undefined,
  precontractualInfo: undefined,
  payPageHandles: undefined,
  creditAccepted: false,
  paypalToken: undefined,
  paypalNounce: undefined,
  contract: undefined,
  recordOfAdviceUrl: null,
  preciItems: [],
};

const productsReducer = (state: ProductState = initialState, action: ProductActions) => {
  switch (action.type) {
    case ProductActionType.SET_PRECONTRACTUAL_INFO:
      return {
        ...state,
        precontractualInfo: action.payload,
      };
    case ProductActionType.SET_RECORD_OF_ADVICE_URL:
      return {
        ...state,
        recordOfAdviceUrl: action.payload,
      };

    case ProductActionType.SET_SELECTED_PRODUCT:
      return {
        ...state,
        selectedProduct: action.payload,
      };
    case ProductActionType.SET_PRODUCT_PLANS:
      return {
        ...state,
        productPlan: action.payload,
      };
    case ProductActionType.SET_PRODUCT_PLAN_LOADED:
      return {
        ...state,
        productPlanLoaded: action.payload,
      };
    case ProductActionType.SET_FILTERED_PRODUCT_PLANS:
      return {
        ...state,
        filteredProductPlan: action.payload,
      };
    case ProductActionType.SET_PAY_PAGE_HANDLES:
      return {
        ...state,
        payPageHandles: action.payload,
      };
    case ProductActionType.SET_CREDIT_ACCEPTED:
      return {
        ...state,
        creditAccepted: action.payload,
      };
    case ProductActionType.SET_PAYPAL_TOKEN:
      return {
        ...state,
        paypalToken: action.payload,
      };
    case ProductActionType.SET_PAYPAL_NOUNCE:
      return {
        ...state,
        paypalNounce: action.payload,
      };

    case ProductActionType.SET_CONTRACT:
      return {
        ...state,
        contract: action.payload,
      };
    case ProductActionType.SET_PRECI_ITEMS:
      return {
        ...state,
        preciItems: action.payload,
      };
    default:
      return state;
  }
};

export default productsReducer;
